import useApiCall from "@hooks/Shared/useApiCall";
import { IUser } from "@interfaces/Users/Users";

const useGetUsers = (projectId: string) =>
  useApiCall<IUser[] | undefined>({
    url: `/projects/${projectId}/users`,
  });

export default useGetUsers;
